import { useSelector } from 'react-redux';
import { selectClient } from '@client/model/selectors';
import { useSession } from '@/features/guided-financial-planning/context';

/**
 * Hook that returns the appropriate multipleFundingSources based on session status.
 *
 * For completed sessions, returns the snapshotted funding sources captured at finalization.
 * For active sessions, returns the live client funding sources.
 *
 * This ensures read-only views of completed sessions show consistent data
 * as it was at the time of completion.
 */
export function useFundingSources(): MultipleFundingSources | undefined {
  const client = useSelector(selectClient);
  const { session } = useSession();

  // For completed sessions, use the snapshot
  if (session?.status === 'completed' && session.stepData?.multipleFundingSourcesSnapshot) {
    return session.stepData.multipleFundingSourcesSnapshot;
  }

  // For active sessions, use live client data
  return client?.multipleFundingSources;
}
